exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-social-link svg[data-v-5de0f954]{width:17px;height:17px}.user-social-link i[data-v-5de0f954]{font-size:17px}", ""]);

// exports
